import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import Toast from '@widgets/Toast';
import NavBar from '@components/NavBar';
import Icon from '@components/Icon';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import BrowserHistory from '@helpers/BrowserHistory';
import { TUser } from '@apis/gloabal';
import { TEditTypes } from './index.d';
import * as Cache from '@helpers/Cache';

export const CacheEditPhoneDataKey = 'CacheEditPhoneDataKey';

export type TConfig = {
  snCode: string,
  company: string,
  isRejectCall?: boolean, // 通话白名单接口
  users: TUser[],
}

type TCacheEditPhoneData = {
  type: TEditTypes,
  selectedIndex: number,
  config: TConfig,
}

const EditPhoneEntry = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [name, setName] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [type, setType] = useState<TEditTypes>();
  const [navBtnEnabled, setNavBtnEnabled] = useState(false);
  const rightNavBtnStyle = navBtnEnabled ? {} : { background: '#BED6FC' };

  const cacheEditPhoneData: TCacheEditPhoneData = Cache.get(CacheEditPhoneDataKey);

  const user = cacheEditPhoneData.config.users?.[cacheEditPhoneData.selectedIndex];

  useEffect(() => {
    setType(cacheEditPhoneData.type);
    setName(user?.name);
    setPhone(user?.phone);
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (name && name.length > 0 && phone && phone.length > 0) {
      setNavBtnEnabled(true);
    } else {
      setNavBtnEnabled(false);
    }
  }, [name, phone])

  const getTitle = () => {
    const operationText = user?.phone ? '修改' : '添加';
    const typeText = {
      parentPhone: '亲情号',
      sosPhone: '联系人',
      contactPhone: '联系人',
    }[type] || '';

    return operationText + typeText;
  }

  const onConfirm = async () => {
    if (navBtnEnabled) {
      if (!/^[0-9]+$/.test(phone)) {
        Toast.show({
          type: 'strip-bottom',
          title: '请输入 1~11 位电话号码'
        });
      } else {
        const users = [...cacheEditPhoneData.config.users];
        users[cacheEditPhoneData.selectedIndex].name = name;
        users[cacheEditPhoneData.selectedIndex].phone = phone;
        users[cacheEditPhoneData.selectedIndex].uid = users[cacheEditPhoneData.selectedIndex].uid || Date.now();
        const reqData = {
          ...cacheEditPhoneData.config,
          snCode: params.current.sncode,
          company: params.current.company,
          users: users.filter((item) => !!item.phone),

        }
        switch(cacheEditPhoneData.type) {
          case 'parentPhone':
            requestParentPhone(reqData);
            break;
          case 'sosPhone':
            requestSosPhone(reqData);
            break;
          case 'contactPhone':
            requestContactPhone(reqData);
            break;
        }
      }
    }
  }

  const requestParentPhone = async (params: any) => {
    const result = await Http.post( Api.PostFamilyConfig, params);
    if(result) {
      BrowserHistory.goBack();
    }
  }

  const requestSosPhone = async (params: any) => {
    const result = await Http.post( Api.PostSosConfig, params);
    if(result) {
      BrowserHistory.goBack();
    }
  }

  const requestContactPhone = async (params: any) => {
    const result = await Http.post( Api.PostContactConfig, params);
    if(result) {
      BrowserHistory.goBack();
    }
  }

  const handlePhoneInput = (e: any) => {
    const value = e.target.value;
    if (/^[0-9]+$/.test(value) || value === '') {
      setPhone(value);
    }
  }

  return (
    <div styleName="container">
      <NavBar
        title={getTitle()}
        RightBtnComponent={
          <div styleName="nav-right-btn" style={rightNavBtnStyle} onClick={onConfirm}>保存</div>
        }
      />
      {
        user &&
        <div styleName="wrapper">
          <div styleName="panel">
            <div styleName="row">
              <div styleName="label">联系人</div>
              <div styleName="input-wrapper">
                <input placeholder="请输入姓名" maxLength={10} value={name} onChange={(e) => setName(e.target.value)} />
              </div>
              { name && name.length > 0 && <Icon type='icon-delete' size={32} onClick={() => setName('')} /> }
            </div>
            <div styleName="row">
              <div styleName="label">电话</div>
              <div styleName="input-wrapper">
                <input placeholder="请输入电话号码" type="tel" maxLength={11} value={phone} onChange={handlePhoneInput} />
              </div>
              { phone && phone.length > 0 && <Icon type='icon-delete' size={32} onClick={() => setPhone('')} /> }
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default EditPhoneEntry;
